import { render, staticRenderFns } from "./DataPrimaryUser.vue?vue&type=template&id=f448fe22&scoped=true"
import script from "./DataPrimaryUser.vue?vue&type=script&lang=js"
export * from "./DataPrimaryUser.vue?vue&type=script&lang=js"
import style0 from "./DataPrimaryUser.vue?vue&type=style&index=0&id=f448fe22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f448fe22",
  null
  
)

export default component.exports